import {EAccessType} from "../enums/access-type.enum";

export const accessDefaultRoutesMap: Record<EAccessType, string> = {
  [EAccessType.FAT]: "/",
  [EAccessType.VERIFY_OTP]: "/auth/verify-2fa",
  [EAccessType.VERIFY_RESET_PASSWORD]: "/auth/verify-forget-password",
  [EAccessType.CONFIRM_RESET_PASSWORD]: "/auth/confirm-forget-password",
  [EAccessType.SET_NEW_PASSWORD]: "/auth/create-new-password",
};
